/* Stack Light Selector wizard.
   Upload to your theme as: assets/sl-selector.js
   Loads on every page but only activates on the blog post that contains
   the wizard markup (a #slBody element). Safe to load site-wide. */
(function () {
  var MODELS = {
    SL30: { name: "SL30 Miniature Stack Light", price: "48.50", url: "https://stack-light.com/products/mini-stack-light",
      img: "https://cdn.shopify.com/s/files/1/2226/6241/files/stack-light-com-stack-light-mini-stack-light-sl30-39741518020827.jpg",
      minC: 3, maxC: 3, fixed3: true, single: false, ip67: false, buzzer: true, sizes: [30], volts: ["24"],
      specs: ["~25 mm", "3 fixed colors", "Indoor", "24V DC"] },
    SL50: { name: "SL50 Andon Light", price: "62.45", url: "https://stack-light.com/products/and-on-light-three-level-sl50",
      img: "https://cdn.shopify.com/s/files/1/2226/6241/files/stack-light-com-stack-light-and-on-light-three-level-sl50-39768284135643.jpg",
      minC: 3, maxC: 3, fixed3: true, single: false, ip67: false, buzzer: true, sizes: [50], volts: ["24"],
      specs: ["50 mm", "3 fixed colors", "IP53", "Built-in 85dB buzzer", "24V DC"] },
    SL60: { name: "SL60 Stack Light", price: "78.00", url: "https://stack-light.com/products/led-stack-lights-24v",
      img: "https://cdn.shopify.com/s/files/1/2226/6241/files/stack-light-com-stack-light-stack-lights-40935201865947.png",
      minC: 1, maxC: 5, fixed3: false, single: false, ip67: false, buzzer: true, sizes: [60], volts: ["24", "110"],
      specs: ["60 mm", "1-5 configurable", "IP53", "85dB buzzer option", "24V or 110V"] },
    SL70: { name: "SL70 Waterproof Andon Light", price: "112.40", url: "https://stack-light.com/products/large-waterproof-andon-light",
      img: "https://cdn.shopify.com/s/files/1/2226/6241/files/SL70-white-when-off-infographic.png",
      minC: 1, maxC: 5, fixed3: false, single: false, ip67: true, buzzer: true, sizes: [70], volts: ["24", "110"],
      specs: ["70 mm", "1-5 configurable", "IP67 waterproof", "85/100dB buzzer option", "24V or 110V"] },
    OD50: { name: "OD50 Waterproof Stack Light", price: "155.30", url: "https://stack-light.com/products/outdoor-andon",
      img: "https://cdn.shopify.com/s/files/1/2226/6241/files/stack-light-com-stack-light-wash-down-stack-light-od50-40195667427547.jpg",
      minC: 2, maxC: 5, fixed3: false, single: false, ip67: true, buzzer: false, sizes: [50], volts: ["24"],
      specs: ["50 mm", "2-5 configurable", "IP67 waterproof", "No buzzer", "24V DC"] },
    MC50: { name: "MC50 Multicolor Tower Light", price: "53.50", url: "https://stack-light.com/products/tower-light-multicolor",
      img: "https://cdn.shopify.com/s/files/1/2226/6241/files/stack-light-com-stack-light-multi-color-tower-light-mc50-39740957393115.jpg",
      minC: 1, maxC: 3, fixed3: false, single: true, ip67: false, buzzer: true, sizes: [50], volts: ["12", "24", "110"],
      specs: ["50 mm", "Single bulb, 3 colors", "Indoor", "Buzzer option", "12V / 24V / 110V"] },
    MC60: { name: "MC60 Multicolor Signal Light", price: "86.00", url: "https://stack-light.com/products/signal-light-multicolor",
      img: "https://cdn.shopify.com/s/files/1/2226/6241/files/stack-light-com-stack-light-24v-dc-yes-multi-color-andon-with-alarm-mc60-39741005758683.jpg",
      minC: 1, maxC: 3, fixed3: false, single: true, ip67: false, buzzer: true, sizes: [60], volts: ["24", "110"],
      specs: ["60 mm", "Single bulb, 3 colors", "Indoor", "Buzzer option", "24V or 110V"] }
  };

  var STEPS = [
    { key: "colors", count: "Question 1 of 6", q: "How many colors do you need?",
      hint: "Each color signals a distinct status, like running, caution, or fault.",
      opts: [
        { v: 1, label: "1 color", sub: "Single on/off or alert. Usually red or green." },
        { v: 2, label: "2 colors", sub: "Two states. Usually red and green." },
        { v: 3, label: "3 colors", sub: "Green, yellow, red (most common)" },
        { v: 4, label: "4-5 colors", sub: "Adds blue / white for extra states" }
      ] },
    { key: "simul", count: "Question 2 of 6", q: "Do you need multiple colors lit at the same time?",
      hint: "Some andons are single lens for showing one color at a time, while others have separate tiers that can be lit simultaneously.",
      opts: [
        { v: "yes", label: "Yes, at the same time", sub: "e.g. green and red lit together" },
        { v: "no", label: "No, one at a time", sub: "Only one status shows at once" }
      ] },
    { key: "env", count: "Question 3 of 6", q: "Whats the environment the light will be in?",
      hint: "This sets the protection (IP) rating you need.",
      opts: [
        { v: "indoor", label: "Indoor / clean", sub: "Office, light-duty, dry" },
        { v: "dusty", label: "Factory floor", sub: "Dust and occasional spray" },
        { v: "washdown", label: "Washdown / outdoor", sub: "Hose-down, wet, or exterior" }
      ] },
    { key: "buzzer", count: "Question 4 of 6", q: "Do you need an audible buzzer?",
      hint: "An alarm draws attention in noisy areas.",
      opts: [
        { v: "yes", label: "Yes, need a buzzer", sub: "Audible alarm required" },
        { v: "no", label: "No buzzer", sub: "Visual signal only" },
        { v: "any", label: "Doesn't matter", sub: "Either is fine" }
      ] },
    { key: "size", count: "Question 5 of 6", q: "Any size preference?",
      hint: "Diameter of the light. Larger is easier to see at a distance.",
      opts: [
        { v: 30, label: "Smallest", sub: "~25 mm mini" },
        { v: 50, label: "Compact", sub: "50 mm" },
        { v: 60, label: "Standard", sub: "60 mm" },
        { v: 70, label: "Large", sub: "70 mm" },
        { v: "any", label: "No preference", sub: "Recommend the best fit" }
      ] },
    { key: "voltage", count: "Question 6 of 6", q: "What voltage is your power source?",
      hint: "Match the light to your machine or supply.",
      opts: [
        { v: "24", label: "24V DC", sub: "Standard for machinery" },
        { v: "110", label: "110-220V AC", sub: "Wall power" },
        { v: "any", label: "Not sure", sub: "Show all options" }
      ] }
  ];

  function init() {
    var bodyEl = document.getElementById("slBody");
    var progEl = document.getElementById("slProgress");
    if (!bodyEl || !progEl) return; // wizard markup not on this page

    var answers = {}, idx = 0;

    function renderProgress() {
      progEl.innerHTML = "";
      for (var i = 0; i < STEPS.length; i++) {
        var s = document.createElement("span");
        if (i < idx) s.className = "done";
        else if (i === idx) s.className = "active";
        progEl.appendChild(s);
      }
    }

    function renderStep() {
      renderProgress();
      var step = STEPS[idx];
      var html = '<p class="sl-step__count">' + step.count + '</p>';
      html += '<p class="sl-step__q">' + step.q + '</p>';
      html += '<p class="sl-step__hint">' + step.hint + '</p>';
      html += '<div class="sl-options">';
      for (var i = 0; i < step.opts.length; i++) {
        var o = step.opts[i];
        var sel = (answers[step.key] === o.v) ? " sel" : "";
        html += '<button class="sl-opt' + sel + '" data-v="' + o.v + '">' + o.label + '<small>' + o.sub + '</small></button>';
      }
      html += '</div>';
      html += '<div class="sl-nav"><button class="sl-back"' + (idx === 0 ? " disabled" : "") + '>&larr; Back</button></div>';
      bodyEl.innerHTML = html;

      var opts = bodyEl.querySelectorAll(".sl-opt");
      for (var j = 0; j < opts.length; j++) {
        opts[j].addEventListener("click", function () {
          var raw = this.getAttribute("data-v");
          var val = (raw === "yes" || raw === "no" || raw === "any" || raw === "indoor" || raw === "dusty" || raw === "washdown" || raw === "24" || raw === "110") ? raw : parseInt(raw, 10);
          answers[STEPS[idx].key] = val;
          if (idx < STEPS.length - 1) { idx++; renderStep(); }
          else { renderResult(); }
        });
      }
      var back = bodyEl.querySelector(".sl-back");
      if (back) back.addEventListener("click", function () { if (idx > 0) { idx--; renderStep(); } });
    }

    function recommend(a) {
      var ids = Object.keys(MODELS);
      var pool = ids.slice();
      pool = pool.filter(function (id) {
        var m = MODELS[id], n = a.colors;
        if (n >= 4) return m.maxC >= 4;
        if (n === 3) return m.maxC >= 3;
        return m.minC <= n;
      });
      if (a.simul === "yes") pool = pool.filter(function (id) { return !MODELS[id].single; });
      if (a.env === "washdown") pool = pool.filter(function (id) { return MODELS[id].ip67; });
      else pool = pool.filter(function (id) { return !MODELS[id].ip67; });
      if (a.buzzer === "yes") pool = pool.filter(function (id) { return MODELS[id].buzzer; });
      if (a.voltage === "110") pool = pool.filter(function (id) { return MODELS[id].volts.indexOf("110") >= 0; });
      if (a.size !== "any") {
        var sized = pool.filter(function (id) { return MODELS[id].sizes.indexOf(a.size) >= 0; });
        if (sized.length) pool = sized;
      }
      var relaxed = false;
      if (pool.length === 0) {
        relaxed = true;
        pool = ids.filter(function (id) {
          var m = MODELS[id], n = a.colors, ok = (n >= 4 ? m.maxC >= 4 : (n === 3 ? m.maxC >= 3 : m.minC <= n));
          if (a.env === "washdown") ok = ok && m.ip67; else ok = ok && !m.ip67;
          return ok;
        });
        if (pool.length === 0) pool = ids.slice();
      }
      function score(id) {
        var m = MODELS[id], s = 0, n = a.colors;
        // SL60 is the versatile flagship: the default multi-tier pick
        if (id === "SL60") s += 4;
        // MC50 is the cheaper default single-bulb
        if (id === "MC50") s += 2;
        // SL30 is a niche tiny light: only ideal when the smallest size is chosen
        if (id === "SL30") s += (a.size === 30 ? 6 : -6);
        // SL50 is the budget 3-tier, sweet spot at 50 mm
        if (id === "SL50" && a.size === 50) s += 3;
        // mild penalty for paying for more colors than needed
        s -= Math.max(0, (m.maxC - Math.max(n, 3))) * 1.0;
        // mild cheaper-is-better tiebreak
        s -= parseFloat(m.price) * 0.02;
        // single-bulb fits "one color at a time"
        if (a.simul === "no" && n <= 3 && m.single) s += 7;
        // washdown routing: SL70 when a buzzer is needed, OD50 when not
        if (a.env === "washdown") {
          if (a.buzzer === "yes" && id === "SL70") s += 6;
          if (a.buzzer === "no" && id === "OD50") s += 6;
        }
        // exact size match
        if (a.size !== "any" && m.sizes.indexOf(a.size) >= 0) s += 3;
        return s;
      }
      pool.sort(function (x, y) { return score(y) - score(x); });
      // Keep the shortlist within the same light class as the top pick
      // (single-bulb vs multi-tier) so we don't mix one stacked light in with single-lens ones.
      var topSingle = MODELS[pool[0]].single;
      var sameClass = pool.filter(function (id) { return MODELS[id].single === topSingle; });
      var top = sameClass.slice(0, 3);
      var list = [top[0]];
      for (var i = 1; i < top.length; i++) {
        if (score(top[i]) >= score(top[0]) - 5.5) list.push(top[i]);
      }
      return { list: list, relaxed: relaxed };
    }

    function whyText(id, a) {
      var bits = [];
      if (a.env === "washdown") bits.push("IP67 waterproof for washdown/outdoor");
      if (a.simul === "yes") bits.push("shows multiple colors at once");
      if (a.simul === "no" && MODELS[id].single) bits.push("sleek single-bulb design");
      if (a.colors >= 4) bits.push("supports 4-5 colors");
      else if (a.colors === 3 && MODELS[id].fixed3) bits.push("exact 3-color (R/Y/G) layout");
      if (a.buzzer === "yes" && MODELS[id].buzzer) bits.push("audible buzzer available");
      if (a.voltage === "110" && MODELS[id].volts.indexOf("110") >= 0) bits.push("available in 110V");
      if (!bits.length) bits.push("solid all-around fit for your answers");
      return bits.join(", ").replace(/^./, function (c) { return c.toUpperCase(); }) + ".";
    }

    function renderResult() {
      idx = STEPS.length; renderProgress();
      for (var k = 0; k < progEl.children.length; k++) progEl.children[k].className = "done";

      var res = recommend(answers);
      var single = res.list.length === 1;
      var html = '<p class="sl-result__intro">' + (single ? "Your best match" : "Your top matches") + '</p>';
      html += '<p class="sl-result__head">' + (single ? "We recommend the " + MODELS[res.list[0]].name.split(" ")[0] : "A couple of models fit your answers") + '</p>';
      html += '<div class="sl-cards">';
      for (var i = 0; i < res.list.length; i++) {
        var id = res.list[i], m = MODELS[id];
        var best = (i === 0);
        html += '<div class="sl-card' + (best ? " best" : "") + '">';
        html += '<div class="sl-card__img"><img src="' + m.img + '" alt="' + m.name + '"></div>';
        html += '<div class="sl-card__info">';
        if (best && !single) html += '<span class="sl-badge">Best fit</span>';
        html += '<p class="sl-card__name">' + m.name + '</p>';
        html += '<p class="sl-card__why">' + whyText(id, answers) + '</p>';
        html += '<div class="sl-specs">';
        for (var s = 0; s < m.specs.length; s++) html += '<span>' + m.specs[s] + '</span>';
        html += '</div>';
        html += '<a class="sl-card__btn" href="' + m.url + '" target="_blank" rel="noopener">View product &rarr;</a>';
        html += '</div></div>';
      }
      html += '</div>';

      var av = answers;
      var cmap = { 1: "1 color", 2: "2 colors", 3: "3 colors", 4: "4-5 colors" };
      var emap = { indoor: "indoor", dusty: "factory floor", washdown: "washdown/outdoor" };
      var smap = { 30: "smallest", 50: "50 mm", 60: "60 mm", 70: "70 mm", any: "any size" };
      var vmap = { "24": "24V DC", "110": "110V AC", any: "any voltage" };
      html += '<p class="sl-summary">Based on: ' + cmap[av.colors] + ', ' + (av.simul === "yes" ? "simultaneous colors" : "one color at a time") + ', ' + emap[av.env] + ', ' + (av.buzzer === "yes" ? "with buzzer" : (av.buzzer === "no" ? "no buzzer" : "buzzer optional")) + ', ' + smap[av.size] + ', ' + vmap[av.voltage] + '.' + (res.relaxed ? " No model met every preference exactly, so this is the closest match - give us a call to fine-tune." : "") + '</p>';
      html += '<button class="sl-restart">&#8635; Start over</button>';
      bodyEl.innerHTML = html;
      bodyEl.querySelector(".sl-restart").addEventListener("click", function () {
        answers = {}; idx = 0; renderStep();
      });
    }

    renderStep();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
